<template>
    <div class="indexContent">
      <div class="content_top">
        <img src="./banner.png" >
      </div>
      <div class="content_middle">
        <div class="visitor" @mouseenter="changePicture" @mouseleave="changePicture" @click="goToRouter('/index/visitorRecord')">
          <div class="visitor1" v-if="this.type">
            <img src="./campus1.png">
            <div style="width: 2.4rem;font-size: .26rem;margin: .23rem 0 0 .69rem;color: #fff">校园访客</div>
            <div style="width: 2.4rem;font-size: .16rem;margin: .20rem 0 0 .73rem;color: #fff">创建平安校园</div>
          </div>
          <div class="visitor2" v-if="!this.type">
            <img src="./campus2.png">
            <div style="width: 2.4rem;font-size: .26rem;margin: .23rem 0 0 .69rem">校园访客</div>
            <div style="width: 2.4rem;font-size: .16rem;margin: .20rem 0 0 .73rem">创建平安校园</div>
          </div>
        </div>

        <div class="feedback" @mouseenter="changePicture1" @mouseleave="changePicture1" @click="goToRouter('/index/feedback')">
          <div class="feedback1" v-if="this.type1">
            <img src="./feedback1.png">
            <div style="width: 100%;font-size: .26rem;margin: .23rem .69rem 0 .69rem;color: #fff">问题反馈</div>
            <div style="width: 100%;font-size: .16rem;margin: .20rem .73rem 0 .73rem;color: #fff">优化育人环境</div>
          </div>
          <div class="feedback2" v-if="!this.type1">
            <img src="./feedback2.png">
            <div style="width: 100%;font-size: .26rem;margin: .23rem .69rem 0 .69rem">问题反馈</div>
            <div style="width: 100%;font-size: .16rem;margin: .20rem .73rem 0 .73rem">优化育人环境</div>
          </div>
        </div>
      </div>
      <div class="content_footer"></div>
    </div>
</template>

<script>
export default {
  name: 'indexContent',
  data () {
    return {
      type: false,
      type1: false,
      routes: []
    }
  },
  methods: {
    goToRouter (path) {
      sessionStorage.setItem('selectId', 0)
      this.$router.push(path)
    },
    changePicture () {
      this.type = !this.type
    },
    changePicture1 () {
      this.type1 = !this.type1
    }
  }
}

</script>

<style scoped>
  .indexContent{
    background-color: #fff;
  }
  .content_top {
    position:relative;
    width:100%;
    height:2rem;
    background: #15bc41;
    overflow:hidden;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, .15)
  }
  .content_top img{
    position:absolute;
    top: 0;
    left:50%;
    display:block;
    margin-left:-9.6rem;
    height:2rem;
  }

  .content_middle {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }

  .visitor {
    margin: .82rem .35rem .82rem 0;
  }

  .visitor1 {
    background:-webkit-linear-gradient(top,#35db49, #34da49,#33d949,#31d748,#30d648,#2fd548,#2dd347,
    #2cd247,#2bd146,#29cf46,#28ce46,#27ce46,#26cc45,#25cc45,#24cc45,#23cc45,#22cc45,#22cc45,#21cc45,
    #20cc45,#1fc543,#1ec443,#1cc343,#1bc142,#19c042,#18bf42,#17bf42,#16bd41,#16bd41,#15bc41);
    border-radius: .1rem;
    width: 2.4rem;
    height: 3.2rem;
    cursor: pointer;
  }

  .visitor1 img {
    margin: .57rem .46rem 0;
    width: 1.48rem;
    height: 1.48rem;
  }

  .visitor2 {
    width: 2.4rem;
    height: 3.2rem;
    flex-direction: column;
    cursor: pointer;
  }

  .visitor2 img {
    margin: .57rem .46rem 0;
    width: 1.48rem;
    height: 1.48rem;
  }

  .feedback {
    margin: .82rem 0 .82rem 0.35rem;
  }
  .feedback1 {
    border-radius: .1rem;
    width: 2.4rem;
    height: 3.2rem;
    cursor: pointer;
    background:-webkit-linear-gradient(top,#35db49, #34da49,#33d949,#31d748,#30d648,#2fd548,#2dd347,
    #2cd247,#2bd146,#29cf46,#28ce46,#27ce46,#26cc45,#25cc45,#24cc45,#23cc45,#22cc45,#22cc45,#21cc45,
    #20cc45,#1fc543,#1ec443,#1cc343,#1bc142,#19c042,#18bf42,#17bf42,#16bd41,#16bd41,#15bc41);
  }
  .feedback1 img {
    margin: .57rem .46rem 0;
    width: 1.48rem;
    height: 1.48rem;
  }

  .feedback2 {
    width: 2.4rem;
    height: 3.2rem;
    flex-direction: column;
    border-radius: .1rem;
    cursor: pointer;
  }

  .feedback2 img {
    margin: .57rem .46rem 0;
    width: 1.48rem;
    height: 1.48rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/indexContent.vue